import { useQuery } from '@apollo/client';
import {
  Challenge,
  DashboardChallengeIdeaStats,
  GET_DASHBOARD_CHALLENGE_IDEA_SUMMARY,
} from '@frontend/data-access';
import { formatNumber } from '@frontend/shared/util';
import { Card } from 'antd';

/* eslint-disable-next-line */
export interface ChallengeDashboardIntraStatsProps {
  challenge: Challenge & { __typename?: string };
}

export function ChallengeDashboardIntraStats({
  challenge,
}: ChallengeDashboardIntraStatsProps) {
  const { data } = useQuery<{
    dashboardChallengeIdeasSummary: DashboardChallengeIdeaStats[];
  }>(GET_DASHBOARD_CHALLENGE_IDEA_SUMMARY, {
    fetchPolicy: 'no-cache',
    variables: {
      challengeId: challenge.id,
    },
  });

  return (
    <Card style={{ borderRadius: 20 }}>
      <div className="flex flex-row divide-x-2 gap-4 text-gray-900">
        {data?.dashboardChallengeIdeasSummary?.map((item, index) => {
          return (
            <div
              key={index}
              className={'flex-1' + (index !== 0 ? ' pl-6' : '')}
            >
              <div
                className="text-base font-normal mb-2"
                data-test={`challenge-dashboard-intra-stats-title-${index}`}
              >
                {item.name}
              </div>
              <div
                className="text-xl font-medium mb-1"
                data-test={`challenge-dashboard-intra-stats-value-${index}`}
              >
                {formatNumber(item.count)}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export default ChallengeDashboardIntraStats;
